module.exports = __webpack_public_path__ + "static/media/login.f37f1458.svg";